import React from "react";
import { DatoHelmet } from "../components/DatoHelmet";
import PageContent from "../components/PageContent";

export default props => {
  const { data, locale } = props;
  const { content, slug, title, seoMetaTags, opensInModal } = data.datoCmsPage;
  const isHome =
    props.location.pathname == "/" || props.location.pathname == `/fr`;
  return (
    <main className={`is-page${isHome ? " is-home" : ""}`}>
      <DatoHelmet seo={seoMetaTags} />
      <PageContent
        title={title}
        content={content}
        locale={locale}
        opensInModal={opensInModal}
      />
    </main>
  );
};

export const query = graphql`
  query PageQuery($slug: String!) {
    datoCmsPage(slug: { eq: $slug }) {
      title
      slug
      opensInModal
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      content {
        type: __typename
        ... on DatoCmsHeroCarousel {
          id
          carouselItems {
            id
            orientation
            image {
              sizes(
                maxWidth: 1440
                imgixParams: { fm: "jpg", auto: "compress", q: 75 }
              ) {
                ...GatsbyDatoCmsSizes
              }
            }
            backgroundAlignment
            mobileImage {
              sizes(
                maxWidth: 750
                imgixParams: { fm: "jpg", auto: "compress", q: 75 }
              ) {
                ...GatsbyDatoCmsSizes
              }
            }
            tagline
            showCalloutButton
            calloutButtonLabel
            calloutButtonLink {
              title
              slug
            }
            blurbNode {
              childMarkdownRemark {
                html
              }
            }
          }
        }
        ... on DatoCmsHero {
          id
          orientation
          image {
            sizes(
              maxWidth: 1440
              imgixParams: { fm: "jpg", auto: "compress", q: 75 }
            ) {
              ...GatsbyDatoCmsSizes
            }
          }
          mobileImage {
            sizes(
              maxWidth: 750
              imgixParams: { fm: "jpg", auto: "compress", q: 75 }
            ) {
              ...GatsbyDatoCmsSizes
            }
          }
          tagline
          taglineColour {
            hex
          }
          showCalloutButton
          calloutButtonLabel
          extendedMobile
        }

        ... on DatoCms4ImageRow {
          id
          images {
            image {
              sizes(
                maxWidth: 350
                imgixParams: { fm: "jpg", auto: "compress", q: 75 }
              ) {
                ...GatsbyDatoCmsSizes
              }
            }
            link {
              id
              title
              slug
            }
            label
            externalLink
            caption
          }
        }
        ... on DatoCmsImageLinkRow {
          id
          links {
            image {
              width
              height
              sizes(
                maxWidth: 375
                imgixParams: { fm: "jpg", auto: "compress", q: 75 }
              ) {
                ...GatsbyDatoCmsSizes
              }
            }
            link {
              id
              title
              slug
            }
            label
            externalLink
            caption
          }
        }
        ... on DatoCmsMasonry {
          id
          tagline
          images {
            sizes(
              maxWidth: 770
              imgixParams: { fm: "jpg", auto: "compress", q: 75 }
            ) {
              ...GatsbyDatoCmsSizes
            }
          }
        }
        ... on DatoCmsParagraph {
          id
          contentNode {
            childMarkdownRemark {
              html
            }
          }
        }
        ... on DatoCmsTextImageBlock {
          id
          orientation
          textNode {
            childMarkdownRemark {
              html
            }
          }
          image {
            sizes(
              maxWidth: 600
              imgixParams: { fm: "jpg", auto: "compress", q: 75 }
            ) {
              ...GatsbyDatoCmsSizes
            }
          }
        }
        ... on DatoCmsQuote {
          id
          contentNode {
            childMarkdownRemark {
              html
            }
          }
        }
        ... on DatoCmsCalloutButton {
          id
          label
          link {
            title
            slug
          }
        }
        ... on DatoCmsLocationsGrid {
          id
          locations {
            title
            location {
              latitude
              longitude
            }
            addressLine1
            addressLine2
            addressLine3
          }
        }
        ... on DatoCmsEmbeddedForm {
          id
          form {
            title
            slug
            introBlurbNode {
              childMarkdownRemark {
                html
              }
            }
            email
            phoneNumber
            formFields {
              type: __typename
              id
              fieldType
              fieldName
              fieldLabel
              required
              placeholderText
              errorText
              selectBoxOptions
            }
            submitButtonLabel
            successHeading
            successBlurbNode {
              childMarkdownRemark {
                html
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/page.js